// extracted by mini-css-extract-plugin
export default {"text":"qPeio","h1":"bFKhO"};